module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAsCAMAAABMt1hMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0+bd2+vjyNLM2tzb6urq6fPt4e7nzdzU9PT04+Tkz+LZ+fv57/by0dHR////3u7pP4YPAQAAANFJREFUeNqs04EKhCAQBNDZWk3N9P//9jQtOt29g+MGguThtEIiDYnxekN5jDG2hIgAEB4UKL/F3BQHyXSTHSTjpnHT3YiEiXoj9pl6I0yed0WVstWJdMKHXVGl1ggr0l6JJDpnVIi+kJXJqFQH0ahU/pnwK5H2LaNStmAou6JKgeGCPMXi4ba5K2zLcjjsjWjbyrrnqCk/9knUlo/4iwZZ2dXrEBqtJZ7Z1Vw3pRGnKb1wTRJ55LB4kTiU8VgkV8+hUJnVy5Tq8ZJMzKKklwADADg3OsJtEQOAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/AL.png
// module id = JEvy
// module chunks = 1